import React from 'react';
import { createRoot } from 'react-dom/client';
import EntryPoint from './EntryPoint';

// Mount the React application
function mountApp() {
  try {
    const rootElement = document.getElementById('root');

    if (rootElement) {
      const root = createRoot(rootElement);
      // Create an object with environment data you need pass to browser. It gonna be replaced on build
      const envData = {
        auth0Domain: __AUTH0_DOMAIN__,
        auth0ClientId: __AUTH0_CLIENT_ID__,
        auth0Audience: __AUTH0_AUDIENCE__,
        auth0RedirectPath: __AUTH0_REDIRECT_PATH__,
        allyApi: __ALLY_DOMAIN__,
      };

      root.render(React.createElement(EntryPoint, { data: envData }));
    } else {
      console.error('Could not find root element');
    }
  } catch (error) {
    console.error('Error mounting React application:', error);
  }
}

// Mount when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
